export const GET_POS_RATIO='GET_POS_RATIO'
export const GET_POS_RATIO_SUCCESS='GET_POS_RATIO_SUCCESS'
export const GET_POS_RATIO_ERROR='GET_POS_RATIO_ERROR'

export const GetPosRatio = (data) => ({
    type: GET_POS_RATIO,
    payload: data
})